var zipCountryLength = {
    'US': [5, 9],
};

module.exports = {
    auth: {
        login: {
            email: {
                required: true,
                normalizer: function(value) {
                    return $.trim(value);
                },
                email: true
            },
            password: {
                required: true,
                minlength: 6
            }
        },
        loginUpdate: {
            email: {
                required: true,
                normalizer: function(value) {
                    return $.trim(value);
                },
                email: true
            }
        }
    },
    subscription: {
        contact: {
            first_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            last_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            email: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
            phone: {
                required: true,
                phoneLite: true,
                minlength: 7
            },
            referrer_by_flyer: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
            country_id: { required: true },
            accept_terms: { required: true },
            // accept_sms_consent: {
            //     required: function(element) {
            //         return $("#phoneInput").length > 0;
            //     },
            // },
            accept_membership: {
                required: function(element) {
                    return $("#membership_type").val() == 'only_membership';
                },
            },
            period_id: { required: true },
            city: { required: true },
            referrer: { required: true },
            zip: {
                required: true,
                zipLite: true,
                exactZipLength: zipCountryLength,
                normalizer: function(value) {return $.trim(value);}
            },
            address1: {
                required: true,
                maxlength: 35,
                normalizer: function(value) {return $.trim(value);}
            },
            state_id: { required: true },
            box_count: { required: true, min: 1, max: 50}
        },
        payment: {
            cpf_cnpj: {
                required: true,
                cpf: true
            }
        },
        success_invite: {
            name_1: {
                required: true,
                normalizer: function(value) {return $.trim(value);}
            },
            email_1: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
        },
        popup: {
            first_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            last_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            email: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
            phone: {
                required: true,
                phoneLite: true,
                minlength: 7
            },
            country_id: {
                required: true
            },
            city: {
                required: true
            },
            address1: {
                required: true,
                maxlength: 35,
                normalizer: function(value) {return $.trim(value);}
            },
            zip: {
                required: true,
                zipLite: true,
                exactZipLength: zipCountryLength,
                normalizer: function(value) {return $.trim(value);}
            },
            state_id: {
                required: true
            },
            referrer: {
                required: true
            }
        },
        popupDonation: {
            first_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            last_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            email: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
            country_id: {
                required: true
            }
        },
        address: {
            address1: {
                required: true,
                maxlength: 35,
                normalizer: function(value) {return $.trim(value);}
            },
            city: {
                required: true,
                normalizer: function(value) {return $.trim(value);}
            },
            state_id: {
                required: true
            },
            zip: {
                required: true,
                zipLite: true,
                exactZipLength: zipCountryLength,
                normalizer: function(value) {return $.trim(value);}
            },
            referrer: {
                required: true
            },
            address2: {
                required: false,
                maxlength: 35,
                normalizer: function(value) {return $.trim(value);}
            }
        },
    },
    profile: {
        subscription: {
            first_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            last_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            phone: {
                required: true,
                phoneLite: true,
                minlength: 7
            },
            address1: {
                required: true,
                maxlength: 35,
                normalizer: function(value) {return $.trim(value);}
            },
            address2: {
                maxlength: 35,
                normalizer: function(value) {return $.trim(value);}
            },
            city: {
                required: true,
                normalizer: function(value) {return $.trim(value);}
            },
            country_id: {
                required: true
            },
            state_id: {
                required: true
            },
            zip: {
                required: true,
                zipLite: true,
                exactZipLength: zipCountryLength,
                normalizer: function(value) {return $.trim(value);}
            }
        },
        referral_account: {
            email: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
            first_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            last_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            phone: {
                required: true,
                phoneLite: true,
                minlength: 7
            },
            address1: {
                required: true,
                maxlength: 35,
                normalizer: function(value) {return $.trim(value);}
            },
            city: {
                required: true,
                normalizer: function(value) {return $.trim(value);}
            },
            country_id: {
                required: true
            },
            state_id: {
                required: true
            },
            zip: {
                required: true,
                zipLite: true,
                exactZipLength: zipCountryLength,
                normalizer: function(value) {return $.trim(value);}
            }
        },
        settings: {
            first_name: {
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            last_name: {
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            email: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
            password: {},
            new_password: {
                required: function(){
                    return $("[name=password]").val() != "";
                },
                minlength: 6,
            },
            new_password_confirmation: {
                required: function(){
                    return $("[name=new_password]").val() != "";
                },
                equalTo: "[name=new_password]",
                minlength: 6
            },
        },
        cancel_subscription: {
            cancel_reason: {
                required: true
            },
            cancel_reason_raw: {
                required: function(element) {
                    let mainReasonValue = $('[name=cancel_reason]').val();
                    return mainReasonValue == 'other';
                },
                maxlength: 255,
                normalizer: function(value) {return $.trim(value);}
            },
        },
        referral_order_cart: {
            cart_address: {
                required: true,
            },
            first_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            last_name: {
                required: true,
                lh_name: true,
                maxlength: 50,
                normalizer: function(value) {return $.trim(value);}
            },
            address1: {
                required: true,
                maxlength: 35,
                normalizer: function(value) {return $.trim(value);}
            },
            address2: {
                maxlength: 35,
                normalizer: function(value) {return $.trim(value);}
            },
            city: {
                required: true,
                normalizer: function(value) {return $.trim(value);}
            },
            country_id: {
                required: true
            },
            state_id: {
                required: true
            },
            zip: {
                required: true,
                zipLite: true,
                exactZipLength: zipCountryLength,
                normalizer: function(value) {return $.trim(value);}
            }
        }
    },
    cancel_flow: {
        cancel: {
            "cancel_reason[other]": { required: true }
        },
        question: {
            question: { required: true }
        },
        period_change: {
            change_type: { required: true }
        },
        choose_subs: {
            order_id: { required: true }
        },
        custom_login_by_code_requets: {
            email: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
        },
        custom_login_by_code: {
            email: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
            code: {
                required: true,
                maxlength: 4,
                minlength: 4,
                normalizer: function(value) {return $.trim(value);}
            },
        },
        custom_login_by_password: {
            email: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
            password: {
                required: true,
                minlength: 6,
                normalizer: function(value) {return $.trim(value);}
            },
        },
    },
    referral_program: {
        participate: {
            email: {
                required: true,
                zoho_email: true,
                maxlength: 80,
                normalizer: function(value) {return $.trim(value);}
            },
        }
    }
}
